import { createContext, useContext, useState, useMemo, ReactNode, useCallback } from 'react';
import { FormFactor } from '../utils/formFactor';
export { DRAG_MIME_TYPE } from './dragConstants';

interface DragInfo {
  /** dashboardBaseId being dragged from the sidebar (external) */
  externalDashboardBaseId?: string;
  /** form factor of the item being dragged (used to highlight compatible slots) */
  formFactor?: FormFactor;
}

interface DashboardDragContextValue {
  drag: DragInfo | null;
  startExternalDrag: (info: DragInfo) => void;
  endExternalDrag: () => void;
}

const DashboardDragContext = createContext<DashboardDragContextValue | undefined>(undefined);

export const DashboardDragProvider = ({ children }: { children: ReactNode }) => {
  const [drag, setDrag] = useState<DragInfo | null>(null);

  const startExternalDrag = useCallback((info: DragInfo) => setDrag(info), []);
  const endExternalDrag = useCallback(() => setDrag(null), []);

  const value = useMemo<DashboardDragContextValue>(
    () => ({ drag, startExternalDrag, endExternalDrag }),
    [drag, startExternalDrag, endExternalDrag]
  );

  return <DashboardDragContext.Provider value={value}>{children}</DashboardDragContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useDashboardDrag = (): DashboardDragContextValue => {
  const ctx = useContext(DashboardDragContext);
  if (!ctx) {
    throw new Error('useDashboardDrag must be used within a DashboardDragProvider');
  }
  return ctx;
};
